import { render, staticRenderFns } from "./game-item.vue?vue&type=template&id=39aefb44&scoped=true"
import script from "./game-item.vue?vue&type=script&lang=js"
export * from "./game-item.vue?vue&type=script&lang=js"
import style0 from "./game-item.vue?vue&type=style&index=0&id=39aefb44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aefb44",
  null
  
)

export default component.exports